__turbopack_context__.v({
  "cell": "BannerLayout-module__7DmkYa__cell",
  "code": "BannerLayout-module__7DmkYa__code",
  "flow": "BannerLayout-module__7DmkYa__flow",
  "grid": "BannerLayout-module__7DmkYa__grid",
});
